"use strict";

require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.define-properties.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.animationTimeout = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.concat.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRadioGroup = require("react-radio-group");
var _formElements = require("@evidation/form-elements");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactTransitionGroup = require("react-transition-group");
var _lodash = _interopRequireDefault(require("lodash"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var animationTimeout = exports.animationTimeout = 150;
var animationDefaultStyle = function animationDefaultStyle(_ref) {
  var duration = _ref.duration;
  return {
    transition: "opacity ".concat(duration, "ms ease-in-out"),
    opacity: 1
  };
};
var transitionStyles = {
  entering: {
    opacity: 0
  },
  entered: {
    opacity: 1
  },
  exiting: {
    opacity: 0
  },
  exited: {
    opacity: 0
  }
};
var FlexContainer = _styledComponents["default"].div.withConfig({
  displayName: "mobile__FlexContainer"
})(["display:flex;flex-flow:column nowrap;"]);
var RadioGroup = (0, _styledComponents["default"])(_reactRadioGroup.RadioGroup).withConfig({
  displayName: "mobile__RadioGroup"
})(["display:flex;flex-flow:column nowrap;padding-bottom:15px;"]);
var Answer = _styledComponents["default"].div.withConfig({
  displayName: "mobile__Answer"
})(["padding:10px;cursor:", ";:not(:last-child):after{content:'';display:block;margin:0 auto;width:100%;padding-top:10px;border-bottom:1px solid black;opacity:0.2;}label{font-size:", "rem;padding-bottom:8px;cursor:inherit !important;}:active{font-weight:", ";}"], function (p) {
  return p.disabled ? "default" : "pointer";
}, 14 / 16, function (p) {
  return p.disabled ? "" : "bold";
});
Answer.label = _styledComponents["default"].label.withConfig({
  displayName: "mobile__label"
})(["p{margin:0 !important;}"]);
var LabelHolder = _styledComponents["default"].div.withConfig({
  displayName: "mobile__LabelHolder"
})(["& > p:first-child{margin:0;font-size:", "rem;}"], 14 / 16);
var Progress = _styledComponents["default"].div.withConfig({
  displayName: "mobile__Progress"
})(["height:5px;margin-bottom:10px;position:relative;background:#f7f7f7;border-radius:25px;box-shadow:inset 0 -1px 1px rgba(196,196,196,0.3);span{display:block;height:100%;border-top-right-radius:8px;border-bottom-right-radius:8px;border-top-left-radius:20px;border-bottom-left-radius:20px;background-color:#ffa400;box-shadow:inset 0 2px 9px rgba(196,196,196,0.3),inset 0 -2px 6px rgba(0,0,0,0.4);position:relative;overflow:hidden;}"]);
var ProgressBar = function ProgressBar(_ref2) {
  var progress = _ref2.progress;
  return /*#__PURE__*/_react["default"].createElement(Progress, null, /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      width: "".concat(progress, "%")
    }
  }));
};
var Mobile = function Mobile(_ref3) {
  var question_label = _ref3.question_label,
    question = _ref3.question,
    answer_labels = _ref3.answer_labels,
    name = _ref3.name,
    onChange = _ref3.onChange,
    _ref3$value = _ref3.value,
    value = _ref3$value === void 0 ? '' : _ref3$value,
    onBack = _ref3.onBack,
    disabled = _ref3.disabled,
    disableBack = _ref3.disableBack,
    progress = _ref3.progress,
    Footer = _ref3.Footer;
  var _useState = (0, _react.useState)(true),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    showQuestion = _useState2[0],
    setShowQuestion = _useState2[1];
  return /*#__PURE__*/_react["default"].createElement(FlexContainer, null, /*#__PURE__*/_react["default"].createElement(ProgressBar, {
    progress: progress
  }), /*#__PURE__*/_react["default"].createElement(LabelHolder, null, question_label), /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.Transition, {
    appear: true,
    "in": showQuestion || progress === 1,
    timeout: animationTimeout
  }, function (state) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: _objectSpread(_objectSpread({
        padding: '10px 0 10px 0'
      }, animationDefaultStyle({
        duration: animationTimeout
      })), transitionStyles[state])
    }, _lodash["default"].isString(question) ? /*#__PURE__*/_react["default"].createElement(_formElements.MarkdownHtml, null, question) : /*#__PURE__*/_react["default"].createElement("p", null, question));
  }), /*#__PURE__*/_react["default"].createElement(RadioGroup, {
    name: name,
    selectedValue: value
  }, answer_labels.map(function (label, i) {
    return /*#__PURE__*/_react["default"].createElement(Answer, {
      disabled: disabled,
      key: label,
      onClick: function onClick(e) {
        if (disabled) return;
        if (progress < 100) setShowQuestion(false);
        e.preventDefault();
        onChange(i);
      }
    }, /*#__PURE__*/_react["default"].createElement(_reactRadioGroup.Radio, {
      id: "phq9-radio-".concat(name, "-").concat(i),
      value: i,
      disabled: disabled,
      readOnly: true
    }), /*#__PURE__*/_react["default"].createElement(Answer.label, {
      htmlFor: "phq9-radio-".concat(name, "-").concat(i)
    }, /*#__PURE__*/_react["default"].createElement(_formElements.MarkdownHtml, null, label)));
  })), Footer && /*#__PURE__*/_react["default"].createElement(Footer, null), !disableBack && /*#__PURE__*/_react["default"].createElement(_formElements.Button, {
    id: "t-previous_button",
    onClick: onBack,
    buttonStyle: "achievement",
    disabled: disableBack
  }, "BACK"));
};
Mobile.defaultProps = {
  value: '',
  meta: {}
};
Mobile.propTypes = {
  name: _propTypes["default"].string.isRequired,
  onChange: _propTypes["default"].func.isRequired,
  progress: _propTypes["default"].number
};
var _default = exports["default"] = Mobile;